/* Eventos de carrinho quando há linhas de kit. Não altera o checkout. */
(function () {
  if (window.TT_KIT_CART) return;
  window.TT_KIT_CART = true;

  function lines() {
    return document.querySelectorAll('[data-tt-kit-line]');
  }

  function kitIds() {
    var ids = [];
    lines().forEach(function (row) {
      var id = row.getAttribute('data-tt-kit-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function track(name, extra) {
    var ids = kitIds();
    if (!ids.length) return;
    var payload = Object.assign({ kit_ids: ids }, extra || {});
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, payload);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
  }

  function bind() {
    if (!lines().length) return;
    if (document.body.classList.contains('template-cart')) {
      track('view_cart_with_kit', {});
    }
    document.querySelectorAll('button[name="checkout"], a[href$="/checkout"]').forEach(function (el) {
      if (el.dataset.ttKitCheckout) return;
      el.dataset.ttKitCheckout = '1';
      el.addEventListener('click', function () {
        track('begin_checkout_with_kit', {});
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
